import {
  DEFAULT_AI_CHAT_MODEL,
  isAllowedOpenAiModel,
  type OpenAiAllowedModels,
} from '@shared/models/ai/ai-models.model';

const AI_CHAT_MODEL_STORAGE_KEY = 'nodon:ai-chat:model';

/**
 * Read the stored model override. Falls back to {@link DEFAULT_AI_CHAT_MODEL}
 * both when there is no stored value and when the stored value is not in the
 * current allowlist (e.g. a model we deprecated since the user last picked).
 */
export const readStoredAiChatModel = (): OpenAiAllowedModels => {
  if (typeof window === 'undefined') return DEFAULT_AI_CHAT_MODEL;
  const raw = window.localStorage.getItem(AI_CHAT_MODEL_STORAGE_KEY);
  return isAllowedOpenAiModel(raw) ? raw : DEFAULT_AI_CHAT_MODEL;
};

/** Persist the design AI chat model override for the next send. */
export const writeStoredAiChatModel = (model: OpenAiAllowedModels): void => {
  window.localStorage.setItem(AI_CHAT_MODEL_STORAGE_KEY, model);
};
